var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12 3.20968 9.29032 0.5 6 0.5C2.68548 0.5 0 3.20968 0 6.5C0 9.81452 2.68548 12.5 6 12.5C9.29032 12.5 12 9.81452 12 6.5ZM5.29839 9.69355C5.15323 9.83871 4.8871 9.83871 4.74194 9.69355L2.22581 7.17742C2.08065 7.03226 2.08065 6.76613 2.22581 6.62097L2.78226 6.08871C2.92742 5.91935 3.16935 5.91935 3.31452 6.08871L5.03226 7.78226L8.66129 4.15323C8.80645 3.98387 9.04839 3.98387 9.19355 4.15323L9.75 4.68548C9.89516 4.83065 9.89516 5.09677 9.75 5.24194L5.29839 9.69355Z",
    fill: "#13A698"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f73ec9b2.svg";
export { ForwardRef as ReactComponent };